import { render, staticRenderFns } from "./ScorePanel.vue?vue&type=template&id=3825661a"
import script from "./ScorePanel.vue?vue&type=script&lang=js"
export * from "./ScorePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports